import React, { useEffect, useState } from "react";
import useAuth from "../hooks/useAuth";
import useMatricula from "../hooks/useMatricula";
import { obtenerLabelEtiqueta } from "../utils/idioma/LabelsIdioma";
import { apiDatosEstudiante, apiDesmatricular, codigoIntitucion, keyPassLogin } from "../config/constantes";
import ModalLoading from "./ModalLoading";
import Swal from 'sweetalert2'
import CryptoJS from "crypto-js";
import { Button, Modal } from "react-bootstrap";


const BtnDesmatricular = ({ mostrarRequisitosAlerta, setMostrarRequisitosAlerta }) => {
  let {
    obtenerDatosEstudiante,
    listadoRequisitosMatricula,
  } = useMatricula();

  const { listadoEtiquetas } = useAuth();
  const [etiquetas, setEtiquetas] = useState({});
  const [disableButton, setDisableButton] = useState(true);
  const [loading, setLoading] = useState(false);
  const [showModalConfirmacion, setShowModalConfirmacion] = useState(false);

  const {
    cinstitucion,
    cpersona,
    dperiodo,
    calumno,
    ndocidentidad,
    cprograma,
    gcondicion,
    cprograma2,
    cperiodo,
    gestado,
    gtipo_periodo,
    gliquida_finanza
  } = obtenerDatosEstudiante || {};

  const prometeValidarApi = (api, config) => {
    return new Promise(async (resolver, rechazar) => {
      try {
        const response = await fetch(api, config);
        const data = await response.json();
        if (response.ok) {
          resolver(data);
        } else {
          rechazar(data);
        }
      } catch (error) {
        setLoading(false);
      }
    });
  };


  let { setObtenerDatosEstudianteSinFiltro, setObtenerDatosEstudiante } = useMatricula();


  let desencriptarTokenSesion = (pass) => {
    let token = pass == null ? "" : pass;
    // Decrypt
    var bytes = CryptoJS.AES.decrypt(token, `${keyPassLogin}`);
    var originalText = bytes.toString(CryptoJS.enc.Utf8);

    return originalText;
  };



  const fetchObtenerDatosEstudiante = async () => {
    let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

    let codEstud = localStorage.getItem("token");
    let desencriptarCode = desencriptarTokenSesion(codEstud);
    let condicionDeCode = desencriptarCode == "" ? false : desencriptarCode;

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cusuario: condicionDeCode,
        p_cinstitucion: codigoIntitucion,
      }),
    };

    try {
      const listaEstudianteJson = await prometeValidarApi(
        `${apiDatosEstudiante}`,
        config
      );
      const { Data, Code, Message } = listaEstudianteJson;
      if (Code === "0") {
        throw new Error(Message);
      }
      setObtenerDatosEstudianteSinFiltro(Data);
      let dataDefault = Data.filter((info) => {
        return info.cprograma == cprograma && info.cperiodo == cperiodo;
      });

      setObtenerDatosEstudiante([]);
      setObtenerDatosEstudiante(dataDefault[0]);
    } catch (error) {
      console.error(
        "Error al actualizar datos del estudiante:",
        error
      );
    };
  } 
 
  
  const fetchDesmatricular = async () => {
    let tokenGlos = JSON.parse(localStorage.getItem("tokenGlo"));

    const config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ` + tokenGlos.access_token,
      },
      body: JSON.stringify({
        p_cinstitucion: cinstitucion,
        p_cprograma: cprograma2,
        p_speriodo: dperiodo,
        p_calumno: calumno,
        p_cpersona: cpersona,
        p_ccarrera: cprograma,
        p_dnialumno: ndocidentidad,
        p_codigoperiodo: dperiodo
      }),
    };
    setLoading(true)
    try {
      const desmatricular = await prometeValidarApi(
        `${apiDesmatricular}`,
        config
      );

      await fetchObtenerDatosEstudiante();

      Swal.fire({
        icon: "success",
        title: "Éxito",
        text: desmatricular?.Message,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#B01333',

        willOpen: () => {
          document.querySelector('.swal2-popup').style.fontFamily = '"Barlow", sans-serif'; // Cambiar la fuente
          document.querySelector('.swal2-popup').style.fontSize = '14px'; // Cambiar el tamaño del texto del modal
        }
      });

    } catch (error) {
      console.log(error, 'error apiii');

      Swal.fire({
        icon: "error",
        title: "Ocurrió un problema",
        text: error?.Data?.mensaje_respuesta,
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#B01333',

        willOpen: () => {
          document.querySelector('.swal2-popup').style.fontFamily = '"Barlow", sans-serif'; // Cambiar la fuente
          document.querySelector('.swal2-popup').style.fontSize = '14px'; // Cambiar el tamaño del texto del modal
        }
      });
    } finally {
      setLoading(false)

    }
  }

  useEffect(() => {
    if (listadoEtiquetas.length > 0) {
      setEtiquetas({
        msj_desmatricular: obtenerLabelEtiqueta(
          "lbl_home_msj_desmatricular",
          listadoEtiquetas
        ),
      });
    }
  }, [listadoEtiquetas]);

  useEffect(() => {

    const todosLosRequisitosCompletados =
      listadoRequisitosMatricula.length > 0 &&
      listadoRequisitosMatricula.every((requisito) => requisito.bcompletado === true);

    const habilitar =

      todosLosRequisitosCompletados &&
      (
        ([1, 2].includes(gtipo_periodo) && gcondicion === 5 && gestado === 1) || //prematriculado
        (gtipo_periodo === 3 && gcondicion === 1 && gestado === 1) || //matriculado y complementario
        (
          gliquida_finanza === 0 &&
          [1, 2].includes(gtipo_periodo) &&
          gcondicion === 1 && gestado === 1
        )
      );

    setDisableButton(!habilitar);
  }, [
    gestado,
    gcondicion,
    gtipo_periodo,
    gliquida_finanza,
    listadoRequisitosMatricula
  ]);

  const { msj_desmatricular } = etiquetas;



  return (
    <div className="my-3 text-center">
      {listadoRequisitosMatricula.length > 0 && obtenerDatosEstudiante.hasOwnProperty('fsistema') == true &&
        <button
          onClick={()=> setShowModalConfirmacion(true)}
          className={`btn ${!disableButton
            ? "btn-primary"
            : "btn-deshabilitado"
            }  w-100 mb-3 d-inline-block`}
          disabled={disableButton}
        >
          <span className="text-decoration-none text-white"  >

            {msj_desmatricular ?? 'Desmatricular'}
          </span>
        </button>}


      {loading && (
        <ModalLoading />
      )}

      <ModalDeConfirmacion
        show={showModalConfirmacion}
        onClose={() => setShowModalConfirmacion(false)}
        onConfirm={async () => {
          setShowModalConfirmacion(false);
          await fetchDesmatricular();
        }}
        title="¿ESTÁ SEGURO DE DESMATRICULAR?"
        message="Una vez confirmado no se podrá revertir los cambios."
        textButton="Aceptar"
        iconType="warning"
      />

    </div>
  );
};

export default BtnDesmatricular;




const shouldShowMessage = (message) => {
  if (typeof message === "string") return message.trim() !== "-";
  if (React.isValidElement(message) && typeof message.props?.children === 'string' && message.props?.children.trim() === "-") return false;
  if (!message) return false;
  return true;
};

const ModalDeConfirmacion = ({
  show,
  onClose,
  onConfirm,
  title,
  message,
  textButton,
  isDisabledButtonConfirm = false,
  hide = false,
  showCancelButton = false,
  cancelButtonText = "Cancelar",
  showCancelButton2 = false,
  cancelButtonText2 = "Cancelar",
  iconType,
}) => {
  const handleClose = () => {
    onClose();
  };

  const renderIcon = () => {
    switch (iconType) {
      case "success":
        return (
          <div className="swal2-success swal2-icon animate__animated animate__wobble">
            <span className="swal2-success-line-tip"></span>
            <span className="swal2-success-line-long"></span>
          </div>
        );
      case "warning":
      default:
        return (
          <div className="icon-pendiente warning animate__animated animate__wobble animate-warning">
            <span className="body"></span>
            <span className="dot"></span>
          </div>
        );
    }
  };


  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <Modal
      centered
      show={show}
      onHide={handleClose}
      backdrop="static" // This prevents the modal from closing on outside click
      autoFocus={false}
      enforceFocus={false}
      restoreFocus={false}
      backdropClassName="modal-backdrop-custom"
    >
      <Modal.Header className="border-bottom-0" closeButton></Modal.Header>
      <Modal.Body className="multicheck py-0">
        <div className="va-middle">
          {renderIcon()}
        </div>
        <div className="text-center">
          <h5 className="text-uppercase">
            {title || "¿Está seguro de procesar la solicitud?"}
          </h5>
          {shouldShowMessage(message) && (
            <h6 className="mb-0 fw-regular">
              {message}
            </h6>
          )}
        </div>
      </Modal.Body>
      <Modal.Footer className=" border-0 mx-auto mb-4">
        {!hide && (
          <>
            {showCancelButton && (
              <Button
                variant="secondary"
                onClick={handleClose}
                className="me-2"
              >
                {cancelButtonText}
              </Button>
            )}
            <Button
              variant="primary"
              onClick={handleConfirm}
              disabled={isDisabledButtonConfirm}
            >
              {textButton || "Aceptar"}
            </Button>
            {showCancelButton2 && (
              <Button
                variant="secondary"
                onClick={handleClose}
                className="me-2"
              >
                {cancelButtonText2}
              </Button>
            )}
          </>
        )}
      </Modal.Footer>
    </Modal>
  );
};

